import React, { useState, useEffect } from 'react';

import { APP_URL } from 'types';
import { SideNavMenu, SideNavMenuItem } from 'carbon-components-react';
import { Integration16 } from '@carbon/icons-react';
import { useHistory } from 'react-router-dom';

export const LeftNavDeveloperTools: React.FC<{}> = () => {
  const history = useHistory();
  const [pathname, setPathname] = useState<string>(history?.location?.pathname);

  useEffect(() => {
    history && setPathname(history.location?.pathname);
  }, [history]);

  return (
    <>
      <SideNavMenu
        renderIcon={Integration16}
        title="Developer tools"
        isActive={pathname.includes(APP_URL.INTEGRATIONS)}
        defaultExpanded={pathname.includes(APP_URL.INTEGRATIONS)}
      >
        <SideNavMenuItem
          isActive={pathname.includes(APP_URL.USERS_API_KEYS)}
          onClick={() => history.push(APP_URL.USERS_API_KEYS)}
        >
          API keys
        </SideNavMenuItem>
        <SideNavMenuItem
          isActive={pathname.includes(APP_URL.WEB_HOOKS_SUBSCRIPTIONS)}
          onClick={() => history.push(APP_URL.WEB_HOOKS_SUBSCRIPTIONS)}
        >
          Web hook subscriptions
        </SideNavMenuItem>
        <SideNavMenuItem
          isActive={pathname.includes(APP_URL.WEB_HOOKS_HISTORY)}
          onClick={() => history.push(APP_URL.WEB_HOOKS_HISTORY)}
        >
          Web hook history
        </SideNavMenuItem>
        <SideNavMenuItem
          isActive={pathname.includes(APP_URL.GIS_INTEGRATIONS)}
          onClick={() => history.push(APP_URL.GIS_INTEGRATIONS)}
        >
          GIS integration
        </SideNavMenuItem>
      </SideNavMenu>
    </>
  );
};

export default LeftNavDeveloperTools;
